import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { AppState } from '../../reducers';
import ProductList from './ProductList';

class Product extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const {loading, loading_category} = this.props;
    return (
      <Spin spinning={ loading || loading_category }>
        <Switch>
          <Route exact path="/product/list" component={ProductList}/>
        </Switch>
      </Spin>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  loading: state.product.loading,
  loading_category: state.category.loading,
});

export default connect(mapStateToProps)(Product);
